import { render, staticRenderFns } from "./yx.vue?vue&type=template&id=22e85620&"
import script from "./yx.vue?vue&type=script&lang=js&"
export * from "./yx.vue?vue&type=script&lang=js&"
import style0 from "./yx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports